import { loadConfig } from "../services/appConfigService";
import http from "../services/api/http";
import { IMedicalQuestionnaireQuestion, MedicalQuestionnaireQuestion_Factory } from "csd.phoenix.models/MedicalQuestionnaireQuestion";
import AsyncLruCache from '../utils/AsyncLruCache';

interface ICacheKey {
  tenantInstallationId: string;
  medicalQuestionnaireId: string;
}

async function _loadQuestionnaire(keyStr: string) {
  const { apiUrl } = await loadConfig();
  const { tenantInstallationId, medicalQuestionnaireId } = JSON.parse(keyStr) as ICacheKey;
  const url = apiUrl.segment(`eforms/external/medicalquestionnaires/default/questions/${tenantInstallationId}`)
    .param({ medicalQuestionnaireId })
    .toString()
  const { data } = await http.get<IMedicalQuestionnaireQuestion[]>(url);
  const result = data.map(mq => MedicalQuestionnaireQuestion_Factory.CreateIncoming(mq)! as IMedicalQuestionnaireQuestion);
  return result;
}

const thirtyMinutes = 1000 * 60 * 30;
const medQCache = new AsyncLruCache<string, IMedicalQuestionnaireQuestion[]>({maxItems: 50, expireAfter: thirtyMinutes, promiseFactory: _loadQuestionnaire })

export async function getDefaultMedicalQuestionnaire(tenantInstallationId: string) {
  const { apiUrl } = await loadConfig();

  const url =  apiUrl
    .segment(`eforms/external/medicalquestionnaires/default/questions/${tenantInstallationId}`)
      .toString();

  const { data } = await http.get<IMedicalQuestionnaireQuestion[]>(url);
  const result = data.map(mq => MedicalQuestionnaireQuestion_Factory.CreateIncoming(mq)! as IMedicalQuestionnaireQuestion);
  return result;
}

export async function getMedicalQuestionnaireByQuestionnaireId(medicalQuestionnaireId: string) {
  const { apiUrl } = await loadConfig();

  const url =  apiUrl
    .segment(`eforms/medicalquestionnaires/${medicalQuestionnaireId}/questions`)
      .toString();

  const { data } = await http.get<IMedicalQuestionnaireQuestion[]>(url);
  const result = data.map(mq => MedicalQuestionnaireQuestion_Factory.CreateIncoming(mq)! as IMedicalQuestionnaireQuestion);
  return result;
}

export async function getMedicalQuestionnaire(tenantInstallationId: string, medicalQuestionnaireId?: string) {
  if (medicalQuestionnaireId) {
    const medQ = await medQCache.get(JSON.stringify({tenantInstallationId, medicalQuestionnaireId}));

    if(medicalQuestionnaireId !== medQ[0]["MedicalQuestionnaireId"]) {
      return getMedicalQuestionnaireByQuestionnaireId(medicalQuestionnaireId);
    }

    return medQ;
  }

  // No medical questionnaire id
  const medQ = await getDefaultMedicalQuestionnaire(tenantInstallationId);
  medQ && medQCache.setExplicitly(JSON.stringify({ tenantInstallationId, medicalQuestionnaireId: medQ[0]!.MedicalQuestionnaireId }), medQ);
  return medQ;
}
